export const CreateNavSections = (sections: IContactSection[]): IReactNavSection[] => {
  let tempSections: IReactNavSection[] = [];

  sections.forEach((section) => {
    let tempSection: IReactNavSection = CreateNavSection(section);
    tempSections.push(tempSection);
  });
  return tempSections;
};

const CreateNavSection = (section: IContactSection): IReactNavSection => {
  let tempSection: IReactNavSection = {
    IncludedStates: section.IncludedStates,
    Link: section.Link,
    Links: CreateNavLinks(section.ContactLinks),
    Title: section.Title,
    Id: section.Id,
  };
  return tempSection;
};

const CreateNavLinks = (links: IContactLink[] | null | undefined): INavigationLink[] => {
  let tempNavLinks: INavigationLink[] = [];
  links?.forEach((lk) => {
    let tempNavLink: INavigationLink = {
      IncludedStates: lk.IncludedStates,
      Link: CreateSitecoreLink(lk),
      OnClick: lk.OnClick,
    };
    tempNavLinks.push(tempNavLink);
  });
  return tempNavLinks;
};

const CreateSitecoreLink = (sLink: IContactLink): ISitecoreLink => {
  let tempLink: ISitecoreLink = {
    Class: sLink.Link?.Class,
    Goal: sLink.Link?.Goal,
    Target: sLink.Link?.Text,
    Text: sLink.Title ?? sLink.Link.Text, // look for title property first
    SubText: sLink.Link?.SubText,
    Url: sLink.Link?.Url?.length > 0 ? sLink.Link.Url : ' ', //default empty to bypass link check
    TargetId: sLink.Id,
    Favoritable: sLink.Link?.Favoritable,
    CaretPosition: sLink.Link?.CaretPosition,
    IsKeyContactLink: true,
  };
  return tempLink;
};
